import { type GovernanceFormSchema, type GovernanceQuerySchema } from '../schemas';

export function governanceQueryToForm(data: GovernanceQuerySchema): GovernanceFormSchema {
  return {
    ...data,
    jurisdiction: data.jurisdiction ?? '',
    registration_number: data.registration_number ?? '',
    registered_agent_name: data.registered_agent_name ?? '',
    notes: data.notes ?? '',
    legal_business_name: data.legal_business_name ?? '',
    supporting_documentation: data.supporting_documentation ?? [],
  };
}
